<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="会议报名表" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="会议报名录入">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="会议报名单编号">
                                            <a-input ref="hybmdbh" v-model="editData.hybmdbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="报名日期" required>
                                            <a-date-picker
                                                ref="bmrq"
                                                style="width:100%"
                                                valueFormat="YYYY-MM-DD"
                                                v-model="editData.bmrq"
                                                placeholder="报名日期"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议名称" required>
                                            <a-input-search read-only ref="hymc" @search="isShow_hyxx = true" v-model="editData.hymc" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_hyxx"
                                                selectNo="JC101601"
                                                :condition="condition"
                                                @saveselect="saveEvent_hyxx(arguments)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议类别">
                                            <a-input ref="hylb" v-model="editData.hylb" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="报名开始时间">
                                            <a-input ref="ksrq" v-model="editData.ksrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="报名结束时间">
                                            <a-input ref="jsrq" v-model="editData.jsrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议开始时间">
                                            <a-input ref="hyksrq" v-model="editData.hyksrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议结束时间">
                                            <a-input ref="hyjsrq" v-model="editData.hyjsrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="会议主要内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="zynr" :rows="3" v-model="editData.zynr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="开会地点">
                                            <a-input ref="hydd" v-model="editData.hydd" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="联系电话">
                                            <a-input ref="lxdh" v-model="editData.lxdh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="纳税人识别号" required>
                                            <a-input ref="nsrsbh" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" v-model="editData.nsrsbh" />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="6">
                                        <a-form-item label="是否交费" required>
                                            <FGDictSelectCN ref="sfjf" dictNo="1101" v-model="editData.sfjf" />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="6">
                                        <a-form-item label="是否收费">
                                            <FGDictSelectCN ref="sfsf" dictNo="1101" v-model="editData.sfsf" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!-- <a-col :span="6">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col> -->
                                    <a-col :span="6">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="会议报名单明细">
                                <vxe-toolbar size="mini">
                                    <template v-slot:tools>
                                        <a-button type="primary" :loading="saving || loading" @click="insertItem">新增</a-button>
                                    </template>
                                </vxe-toolbar>
                                <vxe-table
                                    ref="itemtable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="tableData"
                                    :edit-config="{
                                        trigger: 'click',
                                        mode: 'row',
                                        showStatus: true,
                                        showIcon: false
                                    }"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px"> </vxe-table-column>
                                    <vxe-table-column
                                        field="xm"
                                        title="报名人员"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                        required
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xm" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="xb"
                                        title="性别"
                                        align="center"
                                        width="70px"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="scope.row.xb" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="mz"
                                        title="民族"
                                        align="center"
                                        width="80px"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="mz" dictNo="RY100102" v-model="scope.row.mz" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="sj"
                                        title="手机"
                                        align="center"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" oninput="value=value.replace(/\D/g,'')" v-model="scope.row.sj" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="dzyx"
                                        title="电子发票收件人邮箱"
                                        align="center"
                                        width="140"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                        required
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.dzyx" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="lxdh"
                                        title="联系电话"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" oninput="value=value.replace(/[^0-9-]/g,'')" v-model="scope.row.lxdh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="sfzh"
                                        title="身份证号"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" v-model="scope.row.sfzh" />
                                        </template>
                                    </vxe-table-column>

                                    <vxe-table-column
                                        field="dwdz1"
                                        title="单位地址"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.dwdz1" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="dwlx"
                                        title="单位类型"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.dwlx" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="zwzc"
                                        title="职务或职称"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zwzc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="sfzs"
                                        title="是否住宿"
                                        align="center"
                                        width="80px"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelect ref="sfzs" dictNo="B0001" v-model="scope.row.sfzs" />
                                        </template>
                                        <template v-slot="scope">
                                            <FGDictRenderer ref="sfzs" dictNo="B0001" v-model="scope.row.sfzs" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="zsyq"
                                        title="住宿要求"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="zsyq" dictNo="RY100103" v-model="scope.row.zsyq" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="jhrdsj"
                                        title="计划入店时间"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="jhrdsj" v-model="scope.row.jhrdsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="jhldsj"
                                        title="计划离店时间"
                                        align="center"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-date-picker ref="jhldsj" v-model="scope.row.jhldsj" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="sfyc"
                                        title="是否用餐"
                                        align="center"
                                        width="80px"
                                        header-class-name="required"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <FGDictSelect ref="sfyc" dictNo="B0001" v-model="scope.row.sfyc" />
                                        </template>
                                        <template v-slot="scope">
                                            <FGDictRenderer ref="sfyc" dictNo="B0001" v-model="scope.row.sfyc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column
                                        field="bz"
                                        title="备注"
                                        align="center"
                                        width="220px"
                                        :edit-render="{
                                            type: 'default',
                                            autofocus: 'input'
                                        }"
                                    >
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bz" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column title="操作" width="70" align="center">
                                        <template v-slot="scope">
                                            <span class="btn_edit" @click="removeItem(scope.row)">删除</span>
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <!-- 操作日志 -->
                            <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                        </a-form>
                    </a-spin>
                </a-layout-content>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "BmlrEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            tableData: [],
            isShow_hyxx: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            condition: " AND ZT <> '结束' "
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken", "getNoticeId"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    activated() {
        if (!this.editDataId) {
            this.$FG_helper.handleNewBillCode("HYBMD6001").then((val) => {
                // 新增，设置默认值
                this.editData = {
                    id: this.$FG_util.uuid(),
                    isnew: true,
                    djzt: "制定",
                    hybmdbh: val,
                    djlxid: "HYBMD",
                    bmrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                    bmid: this.getUserInfo.org_id,
                    ryid: this.getUserInfo.personnel_id,
                    yhid: this.getUserInfo.id,
                    dwid: this.getUserInfo.companyInfo.id,
                    lrbmmc: this.getUserInfo.org_name,
                    lrrxm: this.getUserInfo.personnel_name,
                    lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                    lrbj: 1,
                    hymc: "",
                    sfjf: "是"
                };
                if (this.getNoticeId) {
                    this.$FG_http
                        .post(
                            "./api/main/jcsj/hywh/selectById",
                            {
                                id: this.getNoticeId
                            },
                            {
                                showSuccess: false
                            }
                        )
                        .then(({ success, data, errMsg }) => {
                            if (success && data.data) {
                                this.editData.hyid = data.data.id;
                                this.editData.hymc = data.data.hymc;
                                this.editData.hylb = data.data.hylb;
                                this.editData.ksrq = data.data.ksrq;
                                this.editData.jsrq = data.data.jsrq;
                                this.editData.hyksrq = data.data.hyksrq;
                                this.editData.hyjsrq = data.data.hyjsrq;
                                this.editData.zynr = data.data.zynr;
                                this.editData.hydd = data.data.hydd;
                                this.editData.lxr = data.data.lxr;
                                this.editData.lxdh = data.data.lxdh;
                                this.setNoticeId(null);
                            }
                        });
                }
                this.tableData = [];
            });
        } else {
            // 修改，加载数据
            // this.isDeleteShow = false;
            this.loadData();
            this.loadTableData();
        }
        this.condition = ` AND ZT <> '结束' AND (BMDWLB LIKE '%全部%' OR BMDWLB LIKE '%${this.getUserInfo.companyInfo.dwlb}%') `;
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.hymc.focus();
        });
    },
    methods: {
        ...mapActions(["setNoticeId"]),
        saveEvent_hyxx(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.hyid = val[0][0].ID;
                this.editData.hymc = val[0][0].HYMC;
                this.editData.hylb = val[0][0].HYLB;
                this.editData.ksrq = val[0][0].KSRQ;
                this.editData.jsrq = val[0][0].JSRQ;
                this.editData.hyksrq = val[0][0].HYKSRQ;
                this.editData.hyjsrq = val[0][0].HYJSRQ;
                this.editData.zynr = val[0][0].ZYNR;
                this.editData.hydd = val[0][0].HYDD;
                this.editData.lxr = val[0][0].LXR;
                this.editData.lxdh = val[0][0].LXDH;
                this.editData.sfsf = val[0][0].SFSF;
                this.editData.bz = val[0][0].BZ;
            }
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hybm/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            //this.loadTableData();
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        loadTableData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hybm/listMx",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.tableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 新增明细
        insertItem() {
            // 设置编辑记录
            //let xh = this.$refs.itemtable.getInsertRecords().concat(this.$refs.itemtable.getUpdateRecords()).length + 1;
            let xh = this.$refs.itemtable.getTableData().tableData.length + 1;
            this.$refs.itemtable
                .insertAt(
                    {
                        isnew: true,
                        id: this.$FG_util.uuid(),
                        hybmdid: this.editData.id,
                        xh: xh,
                        dwmc: this.getUserInfo.companyInfo.dwmc
                    },
                    -1
                )
                .then(({ row }) => {
                    this.$refs.itemtable.setActiveRow(row);
                });
        },
        // 删除明细
        removeItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.itemtable.remove(row);
                    } else {
                        this.tableDataLoading = true;
                        this.$FG_http
                            .post("./api/main/hybm/deleteMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.tableDataLoading = false;
                                if (success) {
                                    this.loadTableData();
                                }
                            });
                    }
                }
            });
        },
        //提交form
        onSave(btnType) {
            // 获取数据
            let itemData = this.$refs.itemtable.getTableData().tableData;
            let itemRemovedData = [];
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.bmrq) {
                    this.$FG_message.error("P0001", "报名日期").then(() => this.$refs.bmrq.focus());
                    return;
                }
                if (!this.editData.hymc) {
                    this.$FG_message.error("P0001", "会议名称").then(() => this.$refs.hymc.focus());
                    return;
                }
                if (!this.editData.nsrsbh) {
                    this.$FG_message.error("P0001", "纳税人识别号").then(() => this.$refs.nsrsbh.focus());
                    return;
                }

                if (itemData.length === 0) {
                    this.$FG_message.error("请在会议报名单明细中维护报名人员！");
                    return;
                }

                for (let i = 0; i < itemData.length; i++) {
                    if (!itemData[i].xm) {
                        this.$FG_message.error("P0001", "报名人员").then(() => {
                            this.$refs.itemtable.setActiveRow(itemData[i]);
                        });
                        return;
                    }
                    if (!itemData[i].xb) {
                        this.$FG_message.error("P0001", "性别").then(() => {
                            this.$refs.itemtable.setActiveRow(itemData[i]);
                        });
                        return;
                    }
                    if (!itemData[i].sj) {
                        this.$FG_message.error("P0001", "手机").then(() => {
                            this.$refs.itemtable.setActiveRow(itemData[i]);
                        });
                        return;
                    }
                    if (!itemData[i].dzyx) {
                        this.$FG_message.error("P0001", "电子发票收件人邮箱").then(() => {
                            this.$refs.itemtable.setActiveRow(itemData[i]);
                        });
                        return;
                    }
                    if (!itemData[i].sfzs && itemData[i].sfzs !== 0) {
                        this.$FG_message.error("P0001", "是否住宿").then(() => {
                            this.$refs.itemtable.setActiveRow(itemData[i]);
                        });
                        return;
                    }
                    if (!itemData[i].sfyc && itemData[i].sfyc !== 0) {
                        this.$FG_message.error("P0001", "是否用餐").then(() => {
                            this.$refs.itemtable.setActiveRow(itemData[i]);
                        });
                        return;
                    }
                }
            }

            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/hybm/save",
                    {
                        data: this.editData,
                        itemData,
                        itemRemovedData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                    } else {
                        this.$refs.hymc.focus();
                    }
                })
                .then(() => {
                    if (this.editDataId) {
                        if (btnType === 1) {
                            this.submit();
                        } else {
                            this.loadData();
                            this.loadTableData();
                        }
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/hybm/bmlr/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.hymc.focus();
                            }
                        });
                }
            });
        },

        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
